var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetMachine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 575,
    viewBox: "0 0 522 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371 282H91V307H371V282Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333 307L297 282.22",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M424 307H38V488H424V307Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424 488H38V505H424V488Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389 505H73V555H389V505Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 555H95V573H135V555Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M367 555H327V573H367V555Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346 307H123V488H346V307Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190 374H123V421H190V374Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M346 460L190 448V346L346 335V460Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346 439L190 420V375L346 360V439Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M423 488H326L303.92 465.18V371.83L325.74 350.01H423.27L445.09 371.83V465.18L423 488Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M460 2H2V77H460V2Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M460 24H2V55H460V24Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91 13H38V66H91V13Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91 282H38V307H91V282Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M424 282H371V307H424V282Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M438 317H385V342H438V317Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M424 293H325V350H424V293Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13H49V66H80V13Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66H56V282H73V66Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M424 13H371V66H424V13Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413 13H382V66H413V13Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M406 66H389V282H406V66Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 484C410.675 484 440 454.675 440 418.5C440 382.325 410.675 353 374.5 353C338.325 353 309 382.325 309 418.5C309 454.675 338.325 484 374.5 484Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M438.37 325H460C493.14 325 520 351.86 520 385C520 418.14 493.14 445 460 445H445.46L449 431.77H459.23C485.06 431.77 506 410.83 506 385C506 359.17 485.06 338.23 459.23 338.23H438.37V325Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 353V484",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M362.3 353V484",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M350.101 357V481",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M337.9 364V474",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M325.7 374V463",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M386.7 353V484",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M398.9 357V481",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M411.101 364V474",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M423.3 374V463",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M309 418.5H440",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M309 430.7H440",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M313 442.9H437",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M320 455.1H430",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M330 467.3H419",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M309 406.3H440",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M313 394.1H437",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M320 381.9H430",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M330 369.7H419",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M392 401H357V436H392V401Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M385 418.5C385 412.701 380.299 408 374.5 408C368.701 408 364 412.701 364 418.5C364 424.299 368.701 429 374.5 429C380.299 429 385 424.299 385 418.5Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 342C332.25 342 298 376.25 298 418.5C298 460.75 332.25 495 374.5 495C416.75 495 451 460.75 451 418.5C451 376.25 416.75 342 374.5 342ZM374.5 484C338.33 484 309 454.67 309 418.5C309 382.33 338.33 353 374.5 353C410.67 353 440 382.33 440 418.5C440 454.67 410.67 484 374.5 484Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M123.02 307.02L159.02 282.22",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M151 328.5C151 324.91 148.09 322 144.5 322C140.91 322 138 324.91 138 328.5C138 332.09 140.91 335 144.5 335C148.09 335 151 332.09 151 328.5Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151 465.5C151 461.91 148.09 459 144.5 459C140.91 459 138 461.91 138 465.5C138 469.09 140.91 472 144.5 472C148.09 472 151 469.09 151 465.5Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M123 385H190",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123 410H190",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M123 397.5H190",
    stroke: "#282828",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetMachine);
export default __webpack_public_path__ + "static/media/targetMachine.f5a17bdada411859aec7410661c836a3.svg";
export { ForwardRef as ReactComponent };